(() => {
  const THEME_KEY = 'splity-theme-mode';
  const root = document.documentElement;
  const isMode = (value) => value === 'light' || value === 'dark';
  const readMode = () => {
    try {
      const value = localStorage.getItem(THEME_KEY);
      return isMode(value) ? value : 'dark';
    } catch (_) { return 'dark'; }
  };
  const syncTheme = (requested) => {
    const mode = isMode(requested) ? requested : (isMode(root.dataset.splityTheme) ? root.dataset.splityTheme : readMode());
    root.dataset.splityTheme = mode;
    root.style.colorScheme = mode;
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', mode === 'light' ? '#ffffff' : '#000000');
    document.querySelectorAll('[data-splity-theme-toggle]').forEach((button) => {
      button.setAttribute('aria-pressed', String(mode === 'light'));
      button.setAttribute('aria-label', mode === 'light' ? 'Cambiar a modo oscuro' : 'Cambiar a modo claro');
      const label = button.querySelector('[data-splity-theme-label]');
      if (label) label.textContent = mode === 'light' ? 'Claro' : 'Oscuro';
    });
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-splity-theme-toggle]');
    if (!button) return;
    const next = root.dataset.splityTheme === 'light' ? 'dark' : 'light';
    try { localStorage.setItem(THEME_KEY, next); } catch (_) {}
    syncTheme(next);
  });
  window.addEventListener('storage', (event) => {
    if (event.key === THEME_KEY && isMode(event.newValue)) syncTheme(event.newValue);
  });
  syncTheme();
})();

(() => {
  if (window.__splityCheckoutV7) return;
  window.__splityCheckoutV7 = true;

  const MOCK_OWNERS = ['mrupcich','arelga','khrisnna','paulina','edison182','catherinem','dpiko609'];
  const normalize = (value) => String(value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  const cleanText = (node) => String(node?.textContent || '').replace(/\s+/g, ' ').trim();
  const escapeHtml = (value) => String(value ?? '').replace(/[&<>'"]/g, (char) => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[char]));

  const humanizeAccess = (raw) => {
    const value = normalize(raw);
    const map = {
      verification: 'Verificación',
      verificacion: 'Verificación',
      credentials: 'Credenciales',
      credential: 'Credenciales',
      credenciales: 'Credenciales',
      invite: 'Invitación',
      invitation: 'Invitación',
      invitacion: 'Invitación',
      code: 'Código de acceso',
      codigo: 'Código de acceso',
      link: 'Link de invitación',
      profile: 'Perfil',
      perfil: 'Perfil',
      user: 'Usuario de acceso',
      usuario: 'Usuario de acceso'
    };
    if (map[value]) return map[value];
    if (/verification/.test(value)) return 'Verificación';
    if (/credential/.test(value)) return 'Credenciales';
    if (/invit|invite/.test(value)) return 'Invitación';
    if (/codigo|code/.test(value)) return 'Código de acceso';
    if (/usuario|user/.test(value)) return 'Usuario de acceso';
    return raw && String(raw).trim() ? String(raw).trim() : 'Según esta publicación';
  };

  const TERMS = `
    <div class="splity-legal-kicker">INFORMACIÓN LEGAL</div>
    <h2>Términos y Condiciones de Splity</h2>
    <p class="splity-legal-updated">Última actualización: septiembre de 2026</p>
    <p>Estos Términos y Condiciones regulan el uso de <strong>Splity</strong>, plataforma operada por <strong>Splity SpA</strong>, RUT <strong>78.506.886-6</strong>, con domicilio informado en <strong>El Roble 320, Ancud, Chile</strong>, sitio web <strong>splity.cl</strong> y correo <a href="mailto:soporte@splity.cl">soporte@splity.cl</a>.</p>
    <h3>1. Qué es Splity</h3>
    <p>Splity es una <strong>plataforma digital de intermediación entre usuarios</strong>. Permite que usuarios que disponen legítimamente de cupos en planes o suscripciones compatibles publiquen esos cupos y que otros usuarios soliciten acceso. Splity presta servicios de intermediación, verificación, administración de grupos, soporte y gestión de operaciones.</p>
    <p>Splity no es propietaria ni operadora de las plataformas de terceros mencionadas en el sitio. Sus nombres, marcas y logotipos pertenecen a sus respectivos titulares. Su mención sirve para identificar el servicio publicado y no implica afiliación, representación, patrocinio ni autorización comercial.</p>
    <h3>2. Publicación y verificación</h3>
    <p>Quien publique una suscripción declara que cuenta con acceso legítimo y autorización suficiente para administrar o compartir los cupos ofrecidos, que la información proporcionada es verdadera y que mantendrá la suscripción activa durante el período comprometido. Splity podrá solicitar antecedentes y rechazar, pausar o retirar publicaciones que presenten información falsa, riesgo de fraude o incumplimientos.</p>
    <h3>3. Contratación de un cupo</h3>
    <p>Antes del pago, el usuario podrá conocer el servicio o plataforma, plan, modalidad de acceso, precio total del período y condiciones relevantes de la publicación. Al completar el pago acepta las condiciones específicas mostradas para ese cupo.</p>
    <h3>4. Pagos y comisión</h3>
    <p>Los pagos pueden ser procesados por proveedores externos autorizados. Splity podrá cobrar una comisión por sus servicios de intermediación y administración conforme a las condiciones informadas. El monto correspondiente al publicador podrá permanecer retenido mientras se verifica la correcta prestación del servicio.</p>
    <h3>5. Liberación al publicador</h3>
    <p>Como regla operativa inicial, el monto correspondiente al publicador se libera una vez que el usuario ha permanecido <strong>30 días</strong> en el grupo, siempre que el servicio se haya prestado correctamente y no existan incidencias pendientes.</p>
    <h3>6. Problemas de acceso y reubicación</h3>
    <p>Si el usuario pierde acceso, presenta errores persistentes o el grupo deja de funcionar, deberá informar la incidencia a Splity. Según el caso, Splity podrá contactar al publicador, restablecer el acceso, reemplazar la modalidad de acceso o reubicar al usuario en otro grupo equivalente.</p>
    <h3>7. Cancelaciones, retracto y devoluciones</h3>
    <p>Splity respetará los derechos que la legislación chilena vigente reconozca a los consumidores. Los problemas de funcionamiento se gestionarán prioritariamente mediante corrección del acceso o reubicación. Cuando legalmente corresponda una devolución, o no sea posible restablecer ni reemplazar razonablemente el servicio, se gestionará conforme a las condiciones aplicables.</p>
    <h3>8. Renovaciones y cobros posteriores</h3>
    <p>La duración y modalidad de cada contratación se informan antes del pago. Cualquier renovación o cobro posterior deberá respetar las condiciones informadas al usuario. Splity no realizará cargos no informados previamente.</p>
    <h3>9. Conductas prohibidas</h3>
    <p>No se permite proporcionar información falsa, suplantar identidades, cometer fraude, vender accesos obtenidos ilícitamente, utilizar credenciales sin autorización, vulnerar la seguridad de Splity ni realizar contracargos fraudulentos.</p>
    <h3>10. Propiedad intelectual y marcas</h3>
    <p>Los nombres, logotipos y marcas de plataformas mencionadas pertenecen a sus respectivos titulares. Su uso en Splity tiene fines de identificación del servicio publicado y no implica relación comercial con Splity.</p>
    <h3>11. Atención y soporte</h3>
    <p>Las consultas, incidencias y reclamos pueden enviarse a <a href="mailto:soporte@splity.cl">soporte@splity.cl</a> o mediante el Centro de Ayuda de Splity.</p>
    <h3>12. Identificación del operador</h3>
    <ul><li><strong>Razón social:</strong> Splity SpA</li><li><strong>RUT:</strong> 78.506.886-6</li><li><strong>Domicilio informado:</strong> El Roble 320, Ancud, Chile</li><li><strong>Correo:</strong> <a href="mailto:soporte@splity.cl">soporte@splity.cl</a></li><li><strong>Sitio:</strong> splity.cl</li></ul>
  `;

  const PRIVACY = `
    <div class="splity-legal-kicker">TU INFORMACIÓN</div>
    <h2>Política de Privacidad de Splity</h2>
    <p class="splity-legal-updated">Última actualización: septiembre de 2026</p>
    <p><strong>Splity SpA</strong>, RUT <strong>78.506.886-6</strong>, trata datos personales necesarios para operar la plataforma, administrar usuarios y publicaciones, gestionar operaciones, prestar soporte, prevenir fraude y cumplir obligaciones legales.</p>
    <h3>1. Datos tratados</h3><p>Podemos tratar nombre, correo electrónico, teléfono, identificadores de usuario, información de cuenta, publicaciones y grupos, comprobantes de suscripción, datos aportados durante verificaciones, historial de soporte, información técnica y datos necesarios para gestionar o conciliar pagos.</p>
    <h3>2. Datos de acceso</h3><p>En determinadas publicaciones puede ser necesario proporcionar datos de acceso para procesos autorizados de verificación o prestación del servicio. Splity utilizará esta información únicamente para fines relacionados con el servicio y con acceso restringido. Los usuarios no deben proporcionar credenciales que no estén autorizados a compartir.</p>
    <h3>3. Finalidades</h3><p>La información puede utilizarse para crear y administrar cuentas; verificar publicaciones; gestionar cupos y grupos; procesar y conciliar operaciones; brindar soporte; resolver disputas; detectar fraude; proteger la seguridad de Splity y cumplir obligaciones legales.</p>
    <h3>4. Proveedores</h3><p>Cuando un pago sea procesado por un proveedor externo, ese proveedor tratará los datos necesarios conforme a sus propios términos y medidas de seguridad. Splity también podrá utilizar proveedores tecnológicos de alojamiento, comunicaciones, seguridad y soporte.</p>
    <h3>5. Conservación y seguridad</h3><p>La información se conservará durante el tiempo razonablemente necesario para prestar el servicio, resolver incidencias y cumplir obligaciones legales. Splity aplica medidas técnicas y organizativas destinadas a reducir riesgos de acceso, alteración, divulgación o pérdida no autorizada.</p>
    <h3>6. Derechos del titular</h3><p>Los usuarios pueden solicitar, conforme a la legislación aplicable, acceso, rectificación, actualización o eliminación cuando corresponda, escribiendo a <a href="mailto:soporte@splity.cl">soporte@splity.cl</a>.</p>
    <h3>7. Responsable</h3><ul><li><strong>Splity SpA</strong></li><li><strong>RUT:</strong> 78.506.886-6</li><li><strong>Domicilio informado:</strong> El Roble 320, Ancud, Chile</li><li><strong>Correo:</strong> <a href="mailto:soporte@splity.cl">soporte@splity.cl</a></li></ul>
  `;

  const style = document.createElement('style');
  style.id = 'splity-checkout-v7-style';
  style.textContent = `
    .splity-legal-backdrop{position:fixed;inset:0;z-index:2147483600;display:none;align-items:center;justify-content:center;padding:18px;background:rgba(4,2,10,.82);backdrop-filter:blur(8px)}
    .splity-legal-backdrop.is-open{display:flex}.splity-legal-modal{position:relative;width:min(820px,100%);max-height:86vh;overflow:auto;padding:32px;border:1px solid rgba(124,58,237,.42);border-radius:24px;background:#171021;color:#d4ccdc;box-shadow:0 28px 90px rgba(0,0,0,.5);font:500 14px/1.65 Inter,system-ui,sans-serif}.splity-legal-modal h2{margin:4px 42px 8px 0;color:#fff;font-size:28px}.splity-legal-modal h3{margin:23px 0 7px;color:#fff;font-size:16px}.splity-legal-modal a{color:#c4a1ff}.splity-legal-close{position:sticky;float:right;top:0;width:42px;height:42px;border:1px solid rgba(255,255,255,.12);border-radius:13px;background:#38284c;color:#fff;font-size:24px;cursor:pointer}.splity-legal-kicker{color:#61d9ff;font-size:11px;font-weight:900;letter-spacing:.14em}.splity-legal-updated{font-size:12px;opacity:.72}body.splity-legal-lock{overflow:hidden}
    html[data-splity-theme="light"] .splity-legal-modal{background:#fff;color:#475569;border-color:#dac9f1}html[data-splity-theme="light"] .splity-legal-modal h2,html[data-splity-theme="light"] .splity-legal-modal h3{color:#18121f}html[data-splity-theme="light"] .splity-legal-modal a{color:#6d28d9}html[data-splity-theme="light"] .splity-legal-close{background:#f0e7fb;color:#3b2357;border-color:#dbc9ef}
    .splity-contract-summary{margin:14px 0;padding:16px 18px;border:1px solid rgba(111,80,190,.2);border-radius:16px;background:rgba(255,255,255,.96);color:#334155;box-shadow:0 14px 34px rgba(30,21,55,.08)}.splity-contract-summary h3{margin:0 0 12px;color:#17131f;font-size:15px}.splity-contract-summary__grid{display:grid;grid-template-columns:1fr 1fr;gap:10px 16px}.splity-contract-summary__item{display:flex;flex-direction:column;gap:2px}.splity-contract-summary__item small{font-size:11px;color:#64748b}.splity-contract-summary__item strong{color:#17131f;font-size:13px}.splity-contract-summary__notice{margin:13px 0 0;padding-top:11px;border-top:1px solid #eee8f7;font-size:12px;line-height:1.5;color:#596579}.splity-checkout-subscribe{display:none!important}
    .splity-terms .splity-legal-inline{display:inline!important;width:auto!important;min-width:0!important;height:auto!important;min-height:0!important;margin:0!important;padding:0!important;border:0!important;background:transparent!important;color:inherit!important;box-shadow:none!important;text-decoration:underline!important;font:inherit!important;cursor:pointer!important}.splity-terms-error[hidden]{display:none!important}
    .splity-checkout-support-note{margin:12px 0;padding:12px 14px;border:1px solid rgba(16,185,129,.22);border-radius:13px;background:rgba(16,185,129,.08);font-size:12px;line-height:1.55}.splity-checkout-support-note a{color:inherit;font-weight:800}
    .splity-static-group-warning{margin:10px 0;padding:14px 16px;border:1px solid #f5c2c7;border-radius:13px;background:#fff3f4;color:#9f2430;font-size:12px;font-weight:700;text-align:center}
    .splity-legal-identity{display:flex;justify-content:space-between;align-items:center;gap:16px;flex-wrap:wrap;padding:17px clamp(18px,4vw,54px);border-top:1px solid rgba(139,92,246,.2);background:#09070e;color:#d8d1e1;font:600 12px/1.55 Inter,system-ui,sans-serif}.splity-legal-identity strong{display:block;color:#fff;font-size:13px}.splity-legal-identity__links{display:flex;gap:14px;flex-wrap:wrap}.splity-legal-identity button,.splity-legal-identity a{border:0;background:none;padding:0;color:#c4a1ff;font:700 12px Inter,system-ui,sans-serif;cursor:pointer;text-decoration:none}.splity-legal-identity button:hover,.splity-legal-identity a:hover{text-decoration:underline}html[data-splity-theme="light"] .splity-legal-identity{background:#fff;color:#5b5065;border-color:#e8ddf4}html[data-splity-theme="light"] .splity-legal-identity strong{color:#211329}html[data-splity-theme="light"] .splity-legal-identity button,html[data-splity-theme="light"] .splity-legal-identity a{color:#6d28d9}
    @media(max-width:640px){.splity-legal-modal{padding:24px 20px}.splity-legal-modal h2{font-size:23px}.splity-contract-summary{padding:14px}.splity-contract-summary__grid{grid-template-columns:1fr}.splity-legal-identity{padding:17px 18px 88px}}
  `;
  document.head.appendChild(style);

  const ensureLegalRoot = () => {
    if (!document.body || document.getElementById('splity-legal-modal-root')) return;
    const host = document.createElement('div');
    host.id = 'splity-legal-modal-root';
    host.innerHTML = '<div class="splity-legal-backdrop" data-splity-legal-backdrop aria-hidden="true"><div class="splity-legal-modal" role="dialog" aria-modal="true" aria-labelledby="splity-legal-title"><button type="button" class="splity-legal-close" data-splity-legal-close aria-label="Cerrar">×</button><div data-splity-legal-body></div></div></div>';
    document.body.appendChild(host);
  };

  const ensureLegalIdentity = () => {
    if (!document.body || document.querySelector('.splity-legal-identity')) return;
    const el = document.createElement('section');
    el.className = 'splity-legal-identity';
    el.setAttribute('aria-label','Información legal de Splity');
    el.innerHTML = `<div><strong>Splity SpA · RUT 78.506.886-6</strong><span>Plataforma digital de intermediación entre usuarios · El Roble 320, Ancud, Chile</span></div><div class="splity-legal-identity__links"><button type="button" data-splity-legal="terms">Términos y Condiciones</button><button type="button" data-splity-legal="privacy">Política de Privacidad</button><a href="mailto:soporte@splity.cl">soporte@splity.cl</a></div>`;
    document.body.appendChild(el);
  };

  const openLegal = (type) => {
    ensureLegalRoot();
    const backdrop = document.querySelector('[data-splity-legal-backdrop]');
    const body = document.querySelector('[data-splity-legal-body]');
    if (!backdrop || !body) return;
    body.innerHTML = type === 'privacy' ? PRIVACY : TERMS;
    const h2 = body.querySelector('h2');
    if (h2) h2.id = 'splity-legal-title';
    backdrop.classList.add('is-open');
    backdrop.setAttribute('aria-hidden','false');
    document.body.classList.add('splity-legal-lock');
    backdrop.querySelector('[data-splity-legal-close]')?.focus();
  };
  const closeLegal = () => {
    const backdrop = document.querySelector('[data-splity-legal-backdrop]');
    if (!backdrop) return;
    backdrop.classList.remove('is-open');
    backdrop.setAttribute('aria-hidden','true');
    document.body.classList.remove('splity-legal-lock');
  };
  window.SplityLegal = { open: openLegal, close: closeLegal };

  const getPeriod = (checkout) => {
    const button = checkout.querySelector('[data-period].is-active,[data-period].active,[data-period][aria-pressed="true"],[data-checkout-period].is-active');
    const raw = button?.dataset.period || button?.dataset.checkoutPeriod || cleanText(button);
    const value = normalize(raw);
    if (/annual|anual|12 meses/.test(value)) return 'Anual';
    if (/quarter|trimestral|3 meses/.test(value)) return 'Trimestral';
    return /seman/.test(value) ? 'Semanal' : 'Mensual';
  };

  const getAccess = (checkout) => {
    const existing = checkout.querySelector('.splity-contract-summary__item:last-child strong');
    const existingText = cleanText(existing);
    if (existingText && existingText !== '—' && !/según|segun/i.test(existingText)) return humanizeAccess(existingText);
    const candidates = [checkout.dataset.accessMode, checkout.querySelector('[data-access-mode]')?.dataset.accessMode, cleanText(checkout.querySelector('.splity-access-mode'))].filter(Boolean);
    return humanizeAccess(candidates[0] || 'Según esta publicación');
  };

  const getOwner = (checkout) => cleanText(checkout.querySelector('.splity-checkout__card p strong,.splity-checkout-owner strong')) || 'Grupo seleccionado';
  const getPlan = (checkout) => cleanText(checkout.querySelector('.splity-checkout__plan,.splity-checkout-plan strong')) || 'Servicio seleccionado';
  const getPrice = (checkout) => cleanText(checkout.querySelector('.splity-final-price,.splity-checkout-price')) || '—';

  const repairCheckout = (checkout) => {
    if (!(checkout instanceof Element)) return;
    checkout.querySelectorAll('.splity-checkout-subscribe').forEach((node) => node.remove());

    const terms = checkout.querySelector('[data-terms],[data-terms-checkbox]');
    const label = terms?.closest('.splity-terms,label');
    const copy = label?.querySelector('span');
    if (copy && !copy.querySelector('[data-splity-legal]')) {
      copy.innerHTML = `He leído y acepto los <button type="button" class="splity-legal-inline" data-splity-legal="terms">Términos y Condiciones</button> y la <button type="button" class="splity-legal-inline" data-splity-legal="privacy">Política de Privacidad</button>.`;
    }

    const termsError = checkout.querySelector('[data-terms-error],.splity-terms-error');
    if (termsError) termsError.hidden = true;
    if (terms && !terms.dataset.splityV7Bound) {
      terms.dataset.splityV7Bound = '1';
      terms.addEventListener('change', () => { if (termsError) termsError.hidden = true; });
    }

    if (!checkout.querySelector('.splity-checkout-support-note')) {
      const note = document.createElement('p');
      note.className = 'splity-checkout-support-note';
      note.innerHTML = `<strong>Soporte protegido:</strong> si tienes un problema de acceso, Splity gestionará la incidencia y podrá restablecer el acceso o reubicarte en un grupo equivalente según corresponda. Ayuda: <a href="mailto:soporte@splity.cl">soporte@splity.cl</a>.`;
      const confirm = checkout.querySelector('[data-confirm],[data-confirm-buy],.splity-confirm');
      confirm?.insertAdjacentElement('beforebegin', note);
    }

    const owner = normalize(getOwner(checkout));
    if (MOCK_OWNERS.includes(owner)) {
      const confirm = checkout.querySelector('[data-confirm],[data-confirm-buy],.splity-confirm');
      if (confirm) { confirm.disabled = true; confirm.textContent = 'Grupo no disponible'; }
      if (!checkout.querySelector('.splity-static-group-warning')) {
        const warning = document.createElement('p');
        warning.className = 'splity-static-group-warning';
        warning.textContent = 'Este grupo era un dato de demostración y fue retirado del flujo de compra. Selecciona un grupo real aprobado.';
        confirm?.insertAdjacentElement('afterend', warning);
      }
    }
  };

  const removeMockCards = (scope = document) => {
    const cards = [];
    if (scope.matches?.('.splity-buy-group')) cards.push(scope);
    scope.querySelectorAll?.('.splity-buy-group').forEach((card) => cards.push(card));
    cards.forEach((card) => {
      const owner = normalize(card.querySelector('strong')?.textContent || '');
      if (MOCK_OWNERS.includes(owner)) card.remove();
    });
  };

  const scan = (scope = document) => {
    removeMockCards(scope);
    if (scope.matches?.('.splity-checkout')) repairCheckout(scope);
    scope.querySelectorAll?.('.splity-checkout').forEach(repairCheckout);
  };

  document.addEventListener('click', (event) => {
    const legalButton = event.target.closest('[data-splity-legal]');
    if (legalButton) {
      event.preventDefault();
      event.stopPropagation();
      openLegal(legalButton.dataset.splityLegal);
      return;
    }
    if (event.target.closest('[data-splity-legal-close]') || event.target.matches?.('[data-splity-legal-backdrop]')) {
      event.preventDefault();
      closeLegal();
      return;
    }
    const policy = event.target.closest('a[href*="/policies/terms-of-service"],a[href*="/policies/privacy-policy"]');
    if (policy) {
      event.preventDefault();
      openLegal(policy.getAttribute('href').includes('privacy') ? 'privacy' : 'terms');
    }
  }, true);

  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeLegal(); });

  const start = () => {
    ensureLegalRoot();
    ensureLegalIdentity();
    const commerceScope = document.querySelector('[data-splity-services],.splity-checkout,.splity-buy-group,[data-buy-detail],[data-buy-groups]');
    if (!commerceScope) return;
    scan(document);

    const scanQueue = new Set();
    let scanScheduled = false;
    const flushScanQueue = () => {
      scanScheduled = false;
      const nodes = [...scanQueue];
      scanQueue.clear();
      nodes.forEach((node) => scan(node));
    };
    const scheduleScan = () => {
      if (scanScheduled) return;
      scanScheduled = true;
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(flushScanQueue, { timeout: 180 });
      } else {
        window.requestAnimationFrame(flushScanQueue);
      }
    };
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        const relevant = node.matches?.('.splity-buy-group,.splity-checkout') ||
          node.querySelector?.('.splity-buy-group,.splity-checkout');
        if (!relevant) return;
        scanQueue.add(node);
      }));
      if (scanQueue.size) scheduleScan();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
